//import * as workplaceReducer from './workplaceReducer';
import * as registerReducer from './RegisterReducer';
import * as patientReducer from './PatientReducer';

// eslint-disable-next-line no-import-assign
const rootReducer = Object.assign(
    //workplaceReducer
    {},
    registerReducer,
    patientReducer,
);
export default rootReducer;
